import { type FunctionComponent, type SVGProps, memo } from 'react';

interface SvgConverterProps extends SVGProps<SVGSVGElement> {
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  className?: string;
  color?: string;
  disabled?: boolean;
}

const SvgConverter = ({ Icon, className = '', color = 'black', disabled = false, ...rest }: SvgConverterProps) => {
  return (
    <>
      {Icon ? <Icon className={`icon-converter ${className} color-${!disabled ? color : 'muted'}`} {...rest} /> : <></>}
    </>
  );
};

SvgConverter.displayName = 'SvgConverter';

export default memo(SvgConverter);
